<template>
    <span>
        <el-badge class="light-green">
            <el-tooltip class="item" effect="dark" :content="`正在传输`" placement="top-start">
                <el-button type="primary" round :plain="this.tlight.show" style="width:20px;height:20px;" @click="handleTrans"></el-button>
            </el-tooltip>
        </el-badge>
        <el-badge :value="this.blight.num" :hidden="this.blight.bage" class="light-green">
            <el-tooltip class="item" effect="dark" :content="`系统阻塞: ${this.blight.num}条`" placement="top-start">
                <el-button type="warning" round :plain="this.blight.show" style="width:20px;height:20px;" @click="handleBlock"></el-button>
            </el-tooltip>
        </el-badge>
        <el-badge :value="this.elight.num" :hidden="this.elight.bage" class="light-green">
            <el-tooltip class="item" effect="dark" :content="`系统异常: ${this.elight.num}条`" placement="top-start">
                <el-button type="danger" round :plain="this.elight.show" style="width:20px;height:20px;" @click="handleError"></el-button>
            </el-tooltip>
        </el-badge>

        <el-dialog close-on-press-escape append-to-body v-draggable :title="view.title" :visible.sync="view.visible" width="80%">
            <div v-if="view.visible">
                <Error v-if="view.error" :pageSize="10" tableHeight="350px"></Error>
                <Block v-if="view.block" :pageSize="10" tableHeight="350px"></Block>
              <FileContent v-if="view.file" :pageSize="10" tableHeight="350px"></FileContent>
            </div>
        </el-dialog>
    </span>
</template>

<script>
import Error from '@/module/cnetong/client/monitormgr/Error.vue';
import Block from '@/module/cnetong/client/monitormgr/Block.vue';
import FileContent from '@/module/cnetong/client/filepersistent/FilePersistent.vue';
import {config} from "cnetong-core-frontend";

export default {
    name: "Header",
    components: {Error, Block, FileContent},
    props: ['isSenior'],
    data() {
        return {
          timeval:"",
          timevalError:"",
          timevalBlock:"",
            tlight: {
                show: true
            },
            elight: {
                // 亮灯
                show: true,
                num: "0",
                // 显示数字
                bage: true
            },
            blight: {
                // 亮灯
                show: true,
                num: "0",
                // 显示数字
                bage: true
            },
            view: {
                visible: false,
                title: '',
                block: false, // 显示阻塞页面
                error: false, // 显示异常页面
                file: false,//显示文件落地页面
            },
        }
    },
    async mounted() {
        this.initStatusSocket();
        this.initMonitorSocket();
    },
    methods: {
        initStatusSocket() {
            let sock;
            if (process.env.NODE_ENV === 'production') {
                sock = `ws://${config.context.domain}:${config.context.port}/asestatus`;
            } else {
                sock = `ws://localhost:9099/asestatus`;
            }
            let socket = new WebSocket(sock);
            socket.onmessage = e => {
                const data = JSON.parse(e.data);
                if (data.wstype === "ws01") {
                    if (data.scps > 0) {
                      var time = 800;
                      if(data.scps>50){
                        time = 500;
                      }
                      if(data.scps>100){
                        time = 300;
                      }
                      clearInterval(this.timeval);
                      this.timeval = setInterval(() => {
                          this.tlight.show = !this.tlight.show;
                      }, time);
                    } else {
                        clearInterval(this.timeval);
                        this.tlight.show = true;
                    }
                }
            };
            socket.onclose = e => {
                clearInterval(this.timeval);
                this.tlight.show = true;
                console.log("connection closed (" + e.code + ")");
                if (e.code !== 1000) {
                    setTimeout(this.initStatusSocket, 10000);
                }
            };
            this.$once('hook:beforeDestroy', () => socket.close())
        },
        initMonitorSocket() {
          let wsuri_;
          if (process.env.NODE_ENV === 'production') {
            wsuri_ = `ws://${config.context.domain}:${config.context.port}/asemonitor`;
          } else {
            wsuri_ = `ws://localhost:9099/asemonitor`;
          }
          // let wsuri = `ws://localhost:9099/asestatus`;
          const wsuri = wsuri_;
            let socket = new WebSocket(wsuri);
            socket.onmessage = e => {
                console.log(e.data);
                const data = JSON.parse(e.data);
                if (data.wstype === "ws07") {
                    if (data.errors > 0) {
                        this.elight.num = data.errors;
                        clearInterval(this.timevalError);
                        this.timevalError = setInterval(() => {
                            this.elight.bage = false;
                            this.elight.show = !this.elight.show;
                        }, 800);
                    } else {
                        clearInterval(this.timevalError);
                        this.elight.num = '0';
                        this.elight.bage = true;
                        this.elight.show = true;
                    }
                    if (data.blocks > 0) {
                        this.blight.num = data.blocks;
                        clearInterval(this.timevalBlock);
                        this.timevalBlock = setInterval(() => {
                          this.blight.bage = false;
                          this.blight.show = !this.blight.show;
                        }, 800);
                    } else {
                        clearInterval(this.timevalBlock);
                        this.blight.bage = true;
                        this.blight.show = true;
                        this.blight.num = '0';
                    }
                }
            };
            socket.onclose = e => {
                clearInterval(this.timevalError);
                this.elight.bage = true;
                this.elight.show = true;
                this.elight.num = '0';
                clearInterval(this.timevalBlock);
                this.blight.bage = true;
                this.blight.show = true;
                this.blight.num = '0';
                console.log("connection closed (" + e.code + ")");
                if (e.code !== 1000) {
                    setTimeout(this.initMonitorSocket, 10000);
                }
            };
            this.$once('hook:beforeDestroy', () => socket.close())
        },

        async handleTrans() {
          let title = '文件落地查询';
          if (config.isSinglePage) {
            this.view.title = title;
            this.view.file = true;
            this.view.block = false;
            this.view.error = false;
            this.view.visible = true;
          } else {
            await this.confirm(null, `是否跳转至文件落地管理进行查看?`);
            this.removeView(title);
            this.addView(title, '/monitormgr/PersistentFile');
          }
        },
        async handleBlock() {
            let title = '系统阻塞监控';
            if (config.isSinglePage) {
                this.view.title = title;
                this.view.block = true;
                this.view.error = false;
                this.view.file = false;
                this.view.visible = true;
            } else {
                await this.confirm(null, `是否跳转至系统阻塞监控进行查看?`);
                this.removeView(title);
                this.addView(title, '/monitormgr/Block');
            }
        },
        async handleError() {
            let title = '系统异常监控';
            if (config.isSinglePage) {
                this.view.title = title;
                this.view.block = false;
                this.view.error = true;
                this.view.file = false;
                this.view.visible = true;
            } else {
                await this.confirm(null, `是否跳转至系统异常监控进行查看?`);
                this.removeView(title);
                this.addView(title, '/monitormgr/Error');
            }
        },
    }
}
</script>

<style scoped>
.light-green {
    height: 20px !important;
    line-height: 0;
    margin-right: 15px;
}
</style>
